export default {
	categories: [
    {
        "name":"books",
        "icon":"auto_stories"
    },
    {
        "name":"newspapers",
        "icon":"newspaper"
    },
    {
        "name":"photoalbums",
        "icon":"photo_library"
    },
    {
        "name":"notes",
        "icon":"library_music"
    },
    {
        "name":"posters",
        "icon":"ads_click"
    },
    {
        "name":"manuscripts",
        "icon":"history_edu"
    }
    
    
    

    ]
}

